import React from 'react'

import {
  number,
  string,
  bool,
  shape,
  arrayOf,
  oneOf,
} from 'prop-types'

import { emptyReviewsAreaMockedData } from 'Pods/Shared/ItemPageComponents/Mocks/reviewsArea'

import ReviewsArea from './Components/ReviewsArea/ReviewsArea'

function ReviewsAreaWrapper({
  reviewsAreaData,
  currentUsername = '',
  isCurrentUserAdmin = false,
  role,
  canReview,
  locale = 'en',
  extractingCoreStyles,
  productOwnerUsername,
}) {
  const isLoggedIn = Boolean(currentUsername)
  return extractingCoreStyles ? (
    <div className="extraction-versions-wrapper">
      <ReviewsArea {...emptyReviewsAreaMockedData} locale={locale} />
      <ReviewsArea {...reviewsAreaData} userName="" locale={locale} isLoggedIn/>
    </div>
  ) : (
    <ReviewsArea
      {...reviewsAreaData}
      userName={currentUsername}
      isCurrentUserAdmin={isCurrentUserAdmin}
      role={role}
      canReview={canReview}
      locale={locale}
      isLoggedIn={isLoggedIn}
      productId={reviewsAreaData.productId}
      productOwnerUsername={productOwnerUsername}
    />
  )
}

ReviewsAreaWrapper.propTypes = {
  isCurrentUserAdmin: bool,
  locale: string,
  reviewsAreaData: shape({
    productId: number.isRequired,
    commentsCount: number.isRequired,
    comments: arrayOf(shape({
      id: number.isRequired,
      username: string.isRequired,
      content: string.isRequired,
      updatedAt: string.isRequired,
      userRole: oneOf(['seller', 'multiple_buyer', 'buyer', 'community_member']),
    })).isRequired,
    likeCount: number.isRequired,
    dislikeCount: number.isRequired,
    ratings: arrayOf(shape({
      anonymous: bool,
      authorId: number,
      automatedReview: bool,
      avatar: shape({
        small: shape({
          url: string,
        }),
        url: string,
      }),
      comment: string,
      createdAt: string,
      id: number,
      itemId: number,
      score: number,
      updatedAt: string,
      userId: number,
      username: string,
      userRole: oneOf(['seller', 'multiple_buyer', 'buyer', 'community_member']),
    })).isRequired,
    hasMoreComments: bool.isRequired,
    hasMoreRatings: bool.isRequired,
  }).isRequired,
  currentUsername: string,
  role: string.isRequired,
  canReview: bool,
  extractingCoreStyles: bool.isRequired,
  productOwnerUsername: string.isRequired,
}

export default ReviewsAreaWrapper
